<template>
    <app-layout :title="$t('Contacts')">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ $t('Contacts') }}
            </h2>
        </template>


        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <template v-if="consultants.length > 0">
                <ul role="list" class="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <ConsultantContainer v-for="consultant in consultants" :key="consultant.id" :consultant="consultant" />
                </ul>
            </template>
            <template v-else>
                <div class="shadow-md rounded-lg bg-white text-center text-info-400 py-5">
                    {{ $t('Currently no contact persons are available') }}
                </div>
            </template>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import ConsultantContainer from '@/Components/ConsultantContainer.vue'

export default defineComponent({
    components: {
        AppLayout,
        ConsultantContainer,
    },

    props: {
        consultants: Object,
    }
})
</script>
